// extracted by mini-css-extract-plugin
module.exports = {"container":"container--pqb6y","logo":"logo--7fIIZ","title":"title--ALyO2","errorMessage":"errorMessage--TxMaX"};